import React, { Component } from 'react'
import { unitsService } from '../../_services/units.service'
import { Dropdown } from 'semantic-ui-react'
import { connect } from 'react-redux'
import shifts from '../../_constants/shifts'


class ShiftSelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      selectedValue: this.props.defaultValue,
    };
  }

  async componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.state.selectedValue) {
      this.setState({ selectedValue: nextProps.defaultValue });
    }
  }

  handleChange = (e) => {

    let selected = e;
    this.setState({ selectedValue: selected })
    this.props.onChange(selected)

  }

  render() {

    const { loading, defaultValue, disabled } = this.state;
    const { clearable, className } = this.props;

    return (
      <Dropdown
        placeholder=''
        fluid
        search
        selection
        basic
        onChange={(e, data) => this.handleChange(data.value)}
        value={defaultValue}

        className={className}
        options={shifts}
        wrapSelection={false}
        selectOnBlur={false}
        searchInput={{ autoFocus: false }}
        loading={loading}
        disabled={disabled}
        clearable={clearable}
      />
    );
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

const connectedShiftSelect = connect(mapStateToProps)(ShiftSelect);
export { connectedShiftSelect as ShiftSelect };